import {
  Outlet,
  createFileRoute,
  stripSearchParams,
  // useLocation,
  // useNavigate,
} from "@tanstack/react-router";
import { useState } from "react";
// import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { LoadingSpinner } from "@/components/loading";
import { ChromeExtensionModal } from "@/components/modal/ChromeExtensionModal";
// import { PremiumPlanModal } from "@/components/modal/PremiumPlanModal";

const appSearchParamsSchema = z.object({
  initialGreeting: z.boolean().default(false),
});

export const Route = createFileRoute("/_app")({
  component: RouteComponent,
  validateSearch: appSearchParamsSchema,
  search: {
    middlewares: [stripSearchParams({ initialGreeting: false })],
  },
  // async beforeLoad({
  //   context: { queryClient },
  //   location: { searchStr, pathname },
  // }) {
  //   const userPlanPromise = queryClient.ensureQueryData(userPlanQueryOptions);
  //   const userInfo = await queryClient.ensureQueryData(userInfoQueryOptions);

  //   if (userInfo.state === "logged_out") {
  //     const search = new URLSearchParams(searchStr);
  //     if (pathname === "/pricing") return;
  //     // throw redirect({
  //     //   to: "/pub-pricing",
  //     //   search: search as any, // the underlying code can handle an urlsearchparams object but the types dont accept it
  //     //   mask: {
  //     //     to: "/pricing",
  //     //   },
  //     // });
  //     else
  //       throw redirect({
  //         to: "/auth/signin",
  //         search: {
  //           redirect: location.pathname,
  //           redirectSearch: Object.fromEntries(search.entries()),
  //         },
  //       });
  //   } else if (pathname !== "/pricing") {
  //     const userPlan = await userPlanPromise;
  //     if (userPlan.status === "free_plan_expired")
  //       throw redirect({
  //         to: "/pricing",
  //         search: {
  //           freePlanExpired: true,
  //         },
  //       });
  //   }
  // },
  pendingComponent: () => (
    <div className="flex h-screen w-screen grow items-center justify-center">
      <LoadingSpinner size={48} />
    </div>
  ),
});

function RouteComponent() {
  // const navigate = useNavigate();
  // const location = useLocation();
  const { initialGreeting } = Route.useSearch();
  const [showExtensionModal, setShowExtensionModal] =
    useState(!!initialGreeting);

  // const [premiumPlanModal, setPremiumPlanModal] = useState(false);
  // const { data: userInfo } = useQuery(userInfoQueryOptions);
  const handleExtensionModal = (open: boolean) => {
    setShowExtensionModal(open);
    // setPremiumPlanModal(true);
  };

  // const handlePremiumPlanModal = (open: boolean) => {
  //   setPremiumPlanModal(open);
  //   const { initialGreeting, ...searchWithoutGreeting } = location.search;
  //   navigate({
  //     to: location.pathname,
  //     search: searchWithoutGreeting,
  //   });
  // };

  return (
    <DashboardLayout>
      <Outlet />
      <ChromeExtensionModal
        open={showExtensionModal}
        onOpenChange={handleExtensionModal}
      />
      {/* {userInfo?.state === "logged_in" && (
        <PremiumPlanModal
          open={premiumPlanModal}
          onOpenChange={handlePremiumPlanModal}
          userName={userInfo.info.full_name}
        />
      )} */}
    </DashboardLayout>
  );
}
